import React from 'react';
import { IReactionCode } from './ReactionsModel';
import { createUseStyles } from 'react-jss';
import { IonButton } from '@ionic/react';
import { IReactionProps, Reaction } from './Reaction';

const useStyles = createUseStyles({
    button: {
        '--box-shadow': 'none'
    },

    myReaction: {
        borderRadius: 64,
        border: '1px solid var(--ion-color-primary)'
    }
});

export type IReactionBtnCodes = IReactionCode | 'add';

type IReactionButtonProps = IReactionProps & {
    userHasReacted?: boolean;
    filled?: boolean;
    onClick?: (reaction: IReactionBtnCodes, e: React.MouseEvent) => void;
};

export const ReactionButton: React.FC<IReactionButtonProps> = ({ userHasReacted, filled, onClick = () => {}, ...rest }) => {
    const classes = useStyles();

    return (
        <IonButton
            size="small"
            shape="round"
            onClick={e => onClick(rest.reaction, e)}
            data-user-reacted={userHasReacted}
            data-type={`${rest.reaction}-reaction-button`}
            color="light"
            fill={filled ? undefined : 'clear'}
            className={`${classes.button} ${userHasReacted ? classes.myReaction : ''}`}
        >
            <Reaction {...rest} />
        </IonButton>
    );
};
